'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const pageData = [
  { page: 'Homepage', load: 1240 },
  { page: 'Flights', load: 1840 },
  { page: 'Booking', load: 1560 },
  { page: 'PNR', load: 2100 },
  { page: 'Gallery', load: 2340 },
  { page: 'Analytics', load: 2560 },
];

const vitals = [
  { label: 'LCP', value: '1.84s', status: 'good', description: 'Largest Contentful Paint' },
  { label: 'FID', value: '42ms', status: 'good', description: 'First Input Delay' },
  { label: 'CLS', value: '0.08', status: 'good', description: 'Cumulative Layout Shift' },
  { label: 'TTFB', value: '320ms', status: 'good', description: 'Time to First Byte' },
];

const PerformanceAnalyticsAdmin = () => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <div>
        <h2 className="font-heading text-2xl font-bold text-foreground">Performance Analytics</h2>
        <p className="text-sm text-muted-foreground mt-1">Core Web Vitals and page load performance</p>
      </div>
      <Link
        href="/performance-analytics"
        className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg text-sm font-bold hover:bg-primary/90 transition-colors"
      >
        <Icon name="ArrowTopRightOnSquareIcon" size={16} />
        Full Analytics
      </Link>
    </div>

    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {vitals.map((v, i) => (
        <div key={i} className="bg-white rounded-xl border border-green-200 bg-green-50 p-4">
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">{v.label}</span>
            <span className="text-xs font-bold px-2 py-0.5 rounded-full bg-green-100 text-green-700">Good</span>
          </div>
          <div className="text-2xl font-black text-green-600">{v.value}</div>
          <div className="text-xs text-muted-foreground mt-1">{v.description}</div>
        </div>
      ))}
    </div>

    <div className="bg-white rounded-xl border border-border p-5">
      <h3 className="font-heading text-base font-bold text-foreground mb-4">Page Load Times</h3>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={pageData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="page" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={v => `${v}ms`} />
            <Tooltip formatter={(v: number) => [`${v}ms`, 'Load Time']} />
            <Bar dataKey="load" fill="#6366f1" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  </div>
);

export default PerformanceAnalyticsAdmin;
